<template>
    <ion-page class="ion-page" id="main">
        <default-header title="Nieuw bericht"/>
        <ion-content class="bg-image" fullscreen>
            <background slot="fixed"/>

            <flash-messages/>
            <write-message/>
        </ion-content>
    </ion-page>
</template>
<script>
    import WriteMessage from "../../components/messages/WriteMessage";
    import DefaultHeader from "../../components/nav/DefaultHeader";
    import FlashMessages from "../../components/ui-elements/FlashMessages";
    import Background from "../Background";

    export default {
        components: {Background, FlashMessages, DefaultHeader, WriteMessage}
    }
</script>
